import React, { useState } from 'react';
import styles from './BonusDetails.module.css';

const BonusDetails = ({ data }) => {
  const [activeTab, setActiveTab] = useState('Overview');

  const bonusTypes = [
    {
      key: 'dailybonus',
      type: 'Daily Bonus',
      claimed: data?.actualdailybonus || data?.dailybonus || 0,
      icon: '/assets/images/bonus/bcc1.webp',
    },
    {
      key: 'weeklybonus',
      type: 'Weekly Bonus',
      claimed: data?.actualweeklybonus || data?.weeklybonus || 0,
      icon: '/assets/images/bonus/bcc6.webp',
    },
    {
      key: 'monthlybonus',
      type: 'Monthly Bonus',
      claimed: data?.actualmonthlybonus || data?.monthlybonus || 0,
      icon: '/assets/images/bonus/bcc7.webp',
    },
    {
      key: 'depositbonus',
      type: 'Deposit Bonus',
      claimed: data?.depositbonus || 0,
      icon: '/assets/images/bonus/bcc4.webp',
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.tabContainer}>
        <button
          className={`${styles.tab} ${activeTab === 'Overview' ? styles.active : ''}`}
          onClick={() => setActiveTab('Overview')}
        >
          Overview
        </button>
      </div>
      <div className={styles.contentContainer}>
        {activeTab === 'Overview' && (
          <div className={styles.bonusList}>
            {bonusTypes.map((bonus) => (
              <div key={bonus.key} className={styles.bonusItem}>
                <div className={styles.bonusInfo}>
                  <img src={bonus.icon} alt={bonus.type} className={styles.bonusIcon} />
                  <span className={styles.bonusType}>{bonus.type}</span>
                </div>
                <span className={styles.bonusAmount}>
                  ${bonus.claimed.toFixed(2)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BonusDetails;
